module.exports = __webpack_public_path__ + "static/img/rank_avatar_frame_silver.1ca37f82.png";